var i;
((t) => {
  t.sleep = (r) => new Promise((e) => {
    setTimeout(e, r);
  });
  class o {
    constructor() {
      this.resolve = Promise.resolve, this.reject = Promise.reject, this.promise = new Promise((e, s) => {
        this.resolve = e, this.reject = s;
      }), this[Symbol.toStringTag] = "Promise";
    }
    then(e, s) {
      return this.promise.then(e, s);
    }
    catch(e) {
      return this.promise.catch(e);
    }
  }
  t.AsyncTask = o;
})(i || (i = {}));
export {
  i as AsyncAPI
};
//# sourceMappingURL=async.js.map
